import React from 'react';
import { Outlet } from 'react-router-dom';
import { branding } from '../constants/branding';

export const AdminLayout: React.FC = () => {
  return (
    <div style={{ 
      background: branding.pageBackground, 
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Outlet />
    </div>
  );
}; 